// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import { installAnalytics } from "./lib/analytics"

installAnalytics(window, document)
